import type { Skill } from '../skillsData';

export const cryptoskillTradingBData: Skill[] = [
  {
    id: 'bank-official-sonic',
    name: 'bank-official-sonic',
    author: 'Bank Official',
    authorHandle: '@bank_official',
    tag: 'Skill',
    category: 'trading',
    description: 'Bank official Sonic integration. High-frequency trading on Sonic L1 with sub-second finality, order book optimization, and atomic execution.',
    downloads: 6200,
    stars: 440,
    installCommand: '> install the bank-official-sonic skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/bank-official-sonic',
    usageExample: '> trade on Sonic\n> optimize order book\n> execute atomically',
    detailedDescription: 'Bank Official Sonic L1 high-frequency trading module. Leverages Sonic\'s sub-second finality for ultra-low latency execution, optimizes order book interaction for minimal slippage, and supports atomic multi-leg trading strategies with guaranteed settlement.',
  },
  {
    id: 'bank-official-trolls',
    name: 'bank-official-trolls',
    author: 'Bank Official',
    authorHandle: '@bank_official',
    tag: 'Skill',
    category: 'trading',
    description: 'Bank official Trolls social trading. Community-driven trading signals, meme-based sentiment analysis, and viral trend detection for alpha generation.',
    downloads: 4800,
    stars: 350,
    installCommand: '> install the bank-official-trolls skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/bank-official-trolls',
    usageExample: '> detect viral trend\n> analyze meme sentiment\n> trade community signal',
    detailedDescription: 'Bank Official Trolls social sentiment trading module. Monitors crypto Twitter, Reddit, and Discord for viral meme trends and community-driven trading signals. Uses natural language processing to extract alpha from social chatter and execute trades based on crowd-sourced intelligence.',
  },
  {
    id: 'bank-official-vault',
    name: 'bank-official-vault',
    author: 'Bank Official',
    authorHandle: '@bank_official',
    tag: 'Skill',
    category: 'trading',
    description: 'Bank official Vault yield optimization. Automated vault strategies, yield aggregation, and capital-efficient farming across DeFi protocols.',
    downloads: 9800,
    stars: 710,
    installCommand: '> install the bank-official-vault skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/bank-official-vault',
    usageExample: '> deploy vault strategy\n> aggregate yield\n> optimize capital efficiency',
    detailedDescription: 'Bank Official Vault automated yield optimization system. Deploys capital-efficient vault strategies across major DeFi protocols, automatically aggregates yield from multiple sources, and continuously rebalances allocations to maximize risk-adjusted returns.',
  },
  {
    id: 'bank-official-york',
    name: 'bank-official-york',
    author: 'Bank Official',
    authorHandle: '@bank_official',
    tag: 'Skill',
    category: 'trading',
    description: 'Bank official York forex-crypto bridge. Trade forex pairs against crypto, cross-margin between fiat and digital assets, and execute FX arbitrage.',
    downloads: 4200,
    stars: 300,
    installCommand: '> install the bank-official-york skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/bank-official-york',
    usageExample: '> trade forex-crypto pair\n> execute FX arb\n> cross-margin positions',
    detailedDescription: 'Bank Official York forex and crypto trading bridge. Enables trading traditional forex pairs against cryptocurrency collateral, provides cross-margin between fiat currency positions and digital assets, and identifies arbitrage opportunities between forex and crypto exchange rates.',
  },
  {
    id: 'bank-official-zapper',
    name: 'bank-official-zapper',
    author: 'Bank Official',
    authorHandle: '@bank_official',
    tag: 'Skill',
    category: 'trading',
    description: 'Bank official Zapper DeFi integration. One-click DeFi position management, portfolio tracking, and multi-protocol interactions through Zapper.',
    downloads: 7600,
    stars: 540,
    installCommand: '> install the bank-official-zapper skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/bank-official-zapper',
    usageExample: '> manage DeFi positions\n> track portfolio\n> interact with protocols',
    detailedDescription: 'Bank Official Zapper DeFi integration for one-click position management. Manage liquidity pools, yield farms, and lending positions across multiple protocols from a single interface. Real-time portfolio tracking with USD-denominated PnL and impermanent loss monitoring.',
  },
  {
    id: 'basellow-agent',
    name: 'basellow-agent',
    author: 'Basellow',
    authorHandle: '@basellow',
    tag: 'Skill',
    category: 'trading',
    description: 'Basellow trading agent. Base chain automated trading with low-latency execution, gas optimization, and native Base protocol integration.',
    downloads: 8400,
    stars: 600,
    installCommand: '> install the basellow-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/basellow-agent',
    usageExample: '> trade on Base\n> optimize gas\n> execute low-latency',
    detailedDescription: 'Basellow automated trading agent specialized for Base Layer 2. Features low-latency order execution leveraging Base\'s fast block times, automatic gas price optimization for cost-efficient transactions, and native integration with Base-native DeFi protocols like Aerodrome and BaseSwap.',
  },
  {
    id: 'butterfield-agent',
    name: 'butterfield-agent',
    author: 'Butterfield',
    authorHandle: '@butterfield',
    tag: 'Skill',
    category: 'trading',
    description: 'Butterfield options trading agent. Multi-leg options strategies, volatility surface trading, and Greeks-based position management.',
    downloads: 5600,
    stars: 400,
    installCommand: '> install the butterfield-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/butterfield-agent',
    usageExample: '> deploy multi-leg strategy\n> trade volatility surface\n> manage Greeks',
    detailedDescription: 'Butterfield advanced options trading agent for crypto derivatives. Deploys multi-leg strategies including iron condors, butterflies, and straddles. Trades volatility surface discrepancies across Deribit and Lyra, and manages position Greeks for delta-neutral and gamma-scalping approaches.',
  },
  {
    id: 'capix-adaptor',
    name: 'capix-adaptor',
    author: 'Capix',
    authorHandle: '@capix_io',
    tag: 'Skill',
    category: 'trading',
    description: 'Capix adaptor bridge. Connect Capix trading signals and strategies to external execution venues with unified API translation.',
    downloads: 3400,
    stars: 240,
    installCommand: '> install the capix-adaptor skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/capix-adaptor',
    usageExample: '> connect capix signal\n> translate to exchange API\n> execute unified',
    detailedDescription: 'Capix universal trading adaptor providing API translation between Capix signal format and external exchange APIs. Bridges Capix strategy outputs to Binance, Bybit, OKX, and DEX execution venues with unified order format and standardized response handling.',
  },
  {
    id: 'capix-trading-comparison',
    name: 'capix-trading-comparison',
    author: 'Capix',
    authorHandle: '@capix_io',
    tag: 'Skill',
    category: 'trading',
    description: 'Capix trading comparison engine. Benchmark strategies across venues, compare execution quality, and optimize venue selection.',
    downloads: 4800,
    stars: 340,
    installCommand: '> install the capix-trading-comparison skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/capix-trading-comparison',
    usageExample: '> benchmark strategies\n> compare execution quality\n> optimize venue',
    detailedDescription: 'Capix trading performance comparison engine. Benchmarks identical strategies across multiple exchanges and DEXs to measure execution quality, fee impact, and slippage. Recommends optimal venue selection based on historical performance and current market conditions.',
  },
  {
    id: 'clawfi-trading',
    name: 'clawfi-trading',
    author: 'ClawFi',
    authorHandle: '@clawfi',
    tag: 'Skill',
    category: 'trading',
    description: 'ClawFi clawback trading system. MEV-resistant execution, flash loan arbitrage, and atomic sandwich protection for secure trading.',
    downloads: 7200,
    stars: 520,
    installCommand: '> install the clawfi-trading skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/clawfi-trading',
    usageExample: '> execute MEV-resistant\n> flash loan arb\n> protect from sandwich',
    detailedDescription: 'ClawFi secure trading system with built-in MEV resistance. Executes transactions through private mempool submission to prevent sandwich attacks, leverages flash loans for zero-capital arbitrage opportunities, and provides atomic transaction bundling for guaranteed execution outcomes.',
  },
  {
    id: 'conditional-orders-automation',
    name: 'conditional-orders-automation',
    author: 'OrderFlow',
    authorHandle: '@orderflow',
    tag: 'Skill',
    category: 'trading',
    description: 'Conditional orders automation system. OCO, bracket, trailing stop, and trigger-based orders with advanced logic composition.',
    downloads: 12400,
    stars: 890,
    installCommand: '> install the conditional-orders-automation skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/conditional-orders-automation',
    usageExample: '> set OCO order\n> deploy bracket\n> configure trailing stop',
    detailedDescription: 'Advanced conditional order automation system. Supports OCO (one-cancels-other), bracket orders with integrated TP/SL, ATR-based trailing stops, and custom trigger-based orders. Compose complex order logic with multiple conditions, indicators, and time-based rules.',
  },
  {
    id: 'cow-protocol-trading',
    name: 'cow-protocol-trading',
    author: 'CoW Protocol',
    authorHandle: '@cowprotocol',
    tag: 'Skill',
    category: 'trading',
    description: 'CoW Protocol trading integration. Intent-based trading, batch auctions, MEV protection, and solver competition for optimal execution.',
    downloads: 14600,
    stars: 1040,
    installCommand: '> install the cow-protocol-trading skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/cow-protocol-trading',
    usageExample: '> submit intent\n> participate in batch auction\n> execute with MEV protection',
    detailedDescription: 'CoW Protocol (Coincidence of Wants) trading integration for intent-based decentralized trading. Submits trade intents to batch auctions, leverages solver competition for optimal execution prices, and provides guaranteed MEV protection through uniform clearing prices.',
  },
  {
    id: 'cow-swap-agent',
    name: 'cow-swap-agent',
    author: 'CoW Protocol',
    authorHandle: '@cowprotocol',
    tag: 'Skill',
    category: 'trading',
    description: 'CoW Swap automated agent. Smart DEX aggregation, gasless orders, and MEV-protected swaps through CoW Swap infrastructure.',
    downloads: 11200,
    stars: 800,
    installCommand: '> install the cow-swap-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/cow-swap-agent',
    usageExample: '> submit gasless order\n> aggregate DEX routes\n> execute protected swap',
    detailedDescription: 'CoW Swap automated trading agent. Submits gasless off-chain orders for on-chain settlement, aggregates liquidity across all major DEXs for best price execution, and guarantees MEV protection through CoW Protocol\'s batch auction mechanism and solver network.',
  },
  {
    id: 'cow-swap-intelligent-agent',
    name: 'cow-swap-intelligent-agent',
    author: 'CoW Protocol',
    authorHandle: '@cowprotocol',
    tag: 'Skill',
    category: 'trading',
    description: 'CoW Swap intelligent agent. AI-powered order optimization, smart slippage tolerance, and predictive timing for CoW Swap execution.',
    downloads: 7800,
    stars: 560,
    installCommand: '> install the cow-swap-intelligent-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/cow-swap-intelligent-agent',
    usageExample: '> optimize order intelligently\n> set smart slippage\n> predict timing',
    detailedDescription: 'Intelligent CoW Swap agent with AI-powered order optimization. Dynamically adjusts slippage tolerance based on market volatility, predicts optimal order timing based on solver competition patterns, and optimizes trade size for maximum CoW coincidence matching.',
  },
  {
    id: 'cow-swap-mev-protection-agent',
    name: 'cow-swap-mev-protection-agent',
    author: 'CoW Protocol',
    authorHandle: '@cowprotocol',
    tag: 'Skill',
    category: 'trading',
    description: 'CoW Swap MEV protection specialist. Maximum MEV protection through batch auctions, uniform clearing prices, and private order flow.',
    downloads: 9200,
    stars: 660,
    installCommand: '> install the cow-swap-mev-protection-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/cow-swap-mev-protection-agent',
    usageExample: '> enable MEV protection\n> submit private order\n> batch execute safely',
    detailedDescription: 'CoW Swap MEV protection specialist ensuring zero sandwich attacks and front-running. Routes orders through private mempool channels, leverages CoW Protocol\'s batch auction for uniform clearing prices, and provides MEV rebate sharing for protected order flow submission.',
  },
  {
    id: 'crypto-alpha-scanner',
    name: 'crypto-alpha-scanner',
    author: 'AlphaScan',
    authorHandle: '@alphascan',
    tag: 'Skill',
    category: 'trading',
    description: 'Crypto alpha scanner. Detect early-stage opportunities, wallet tracking, and on-chain signal monitoring for alpha generation.',
    downloads: 15800,
    stars: 1130,
    installCommand: '> install the crypto-alpha-scanner skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/crypto-alpha-scanner',
    usageExample: '> scan for alpha\n> track smart wallets\n> monitor on-chain signals',
    detailedDescription: 'Comprehensive crypto alpha detection scanner. Monitors blockchain for early-stage token launches and liquidity additions, tracks smart money wallet movements for copy-trading opportunities, and analyzes on-chain signals including exchange inflows, large transfers, and unusual activity patterns.',
  },
  {
    id: 'crypto-strategy-suite',
    name: 'crypto-strategy-suite',
    author: 'StrategyHub',
    authorHandle: '@strategyhub',
    tag: 'Skill',
    category: 'trading',
    description: 'Crypto strategy suite. Pre-built trading strategies, backtesting framework, and strategy marketplace for automated crypto trading.',
    downloads: 18600,
    stars: 1340,
    installCommand: '> install the crypto-strategy-suite skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/crypto-strategy-suite',
    usageExample: '> browse strategies\n> backtest selection\n> deploy automated',
    detailedDescription: 'Comprehensive crypto trading strategy suite with pre-built algorithmic strategies including momentum, mean-reversion, breakout, and grid trading. Built-in backtesting framework with historical data, strategy marketplace for community-created bots, and one-click automated deployment.',
  },
  {
    id: 'crypto-whale-tracker',
    name: 'crypto-whale-tracker',
    author: 'WhaleWatch',
    authorHandle: '@whalewatch',
    tag: 'Skill',
    category: 'trading',
    description: 'Crypto whale tracking and alert system. Monitor large wallet movements, exchange inflows/outflows, and whale accumulation patterns.',
    downloads: 21400,
    stars: 1530,
    installCommand: '> install the crypto-whale-tracker skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/crypto-whale-tracker',
    usageExample: '> track whale wallets\n> alert on exchange flow\n> detect accumulation',
    detailedDescription: 'Advanced whale tracking system for crypto markets. Monitors top 1000 holder wallets for Bitcoin and Ethereum, tracks large exchange inflows and outflows that precede volatility, detects accumulation and distribution patterns, and generates real-time alerts with historical context.',
  },
  {
    id: 'darwin-fi',
    name: 'darwin-fi',
    author: 'DarwinFi',
    authorHandle: '@darwinfi',
    tag: 'Skill',
    category: 'trading',
    description: 'DarwinFi evolutionary trading. Strategy evolution through genetic algorithms, survival of the fittest backtesting, and adaptive strategy mutation.',
    downloads: 6400,
    stars: 460,
    installCommand: '> install the darwin-fi skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/darwin-fi',
    usageExample: '> evolve strategies\n> run genetic backtest\n> mutate parameters',
    detailedDescription: 'DarwinFi evolutionary trading framework using genetic algorithms for strategy optimization. Evolves trading strategies through selection, crossover, and mutation operators. Runs survival-of-the-fittest backtesting competitions, automatically promotes high-Sharpe strategies, and adapts parameters to changing market regimes.',
  },
  {
    id: 'dca-automation-engine',
    name: 'dca-automation-engine',
    author: 'DCA Tools',
    authorHandle: '@dcatools',
    tag: 'Skill',
    category: 'trading',
    description: 'DCA automation engine. Dollar-cost averaging with smart entry timing, volatility-adjusted intervals, and multi-asset basket DCA.',
    downloads: 16800,
    stars: 1200,
    installCommand: '> install the dca-automation-engine skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/dca-automation-engine',
    usageExample: '> setup smart DCA\n> adjust by volatility\n> multi-asset basket',
    detailedDescription: 'Advanced dollar-cost averaging automation engine. Implements smart entry timing that accelerates purchases during high volatility and pauses during euphoria. Supports multi-asset basket DCA with dynamic weight allocation, custom interval scheduling, and automated portfolio rebalancing.',
  },
  {
    id: 'dca-automation',
    name: 'dca-automation',
    author: 'DCA Tools',
    authorHandle: '@dcatools',
    tag: 'Skill',
    category: 'trading',
    description: 'DCA automation basic. Simple dollar-cost averaging with fixed intervals, amount scheduling, and basic performance tracking.',
    downloads: 12400,
    stars: 890,
    installCommand: '> install the dca-automation skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/dca-automation',
    usageExample: '> setup fixed DCA\n> schedule amounts\n> track performance',
    detailedDescription: 'Simple and reliable dollar-cost averaging automation. Set fixed purchase intervals (daily, weekly, monthly), schedule exact purchase amounts, and track accumulated positions with basic performance metrics including average entry price and unrealized PnL.',
  },
  {
    id: 'debo-trading-agent',
    name: 'debo-trading-agent',
    author: 'DeBo',
    authorHandle: '@debo_trading',
    tag: 'Skill',
    category: 'trading',
    description: 'DeBo trading agent. Automated meme coin trading, social sentiment analysis, and viral trend detection with risk controls.',
    downloads: 9800,
    stars: 700,
    installCommand: '> install the debo-trading-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/debo-trading-agent',
    usageExample: '> trade meme coins\n> analyze sentiment\n> detect viral trend',
    detailedDescription: 'DeBo automated trading agent specialized for meme coin and viral token markets. Monitors social media platforms for emerging trends, analyzes sentiment velocity for early entry signals, and deploys automated trades with strict risk controls and position sizing limits for volatile assets.',
  },
  {
    id: 'debo-trading',
    name: 'debo-trading',
    author: 'DeBo',
    authorHandle: '@debo_trading',
    tag: 'Skill',
    category: 'trading',
    description: 'DeBo trading suite. Core trading functionality for DeBo ecosystem including order management, portfolio tracking, and execution analytics.',
    downloads: 7200,
    stars: 520,
    installCommand: '> install the debo-trading skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/debo-trading',
    usageExample: '> manage orders\n> track portfolio\n> view execution analytics',
    detailedDescription: 'DeBo core trading suite providing essential trading functionality. Manage open and pending orders across multiple venues, track portfolio performance with detailed PnL attribution, and access execution analytics including fill quality, slippage analysis, and venue comparison.',
  },
  {
    id: 'deffy-dca-scanner',
    name: 'deffy-dca-scanner',
    author: 'Deffy',
    authorHandle: '@deffy_io',
    tag: 'Skill',
    category: 'trading',
    description: 'Deffy DCA scanner. Identify optimal DCA entry points, scan for DCA-friendly assets, and automate best-in-class dollar-cost averaging.',
    downloads: 5600,
    stars: 400,
    installCommand: '> install the deffy-dca-scanner skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/deffy-dca-scanner',
    usageExample: '> scan DCA opportunities\n> identify optimal entry\n> automate DCA',
    detailedDescription: 'Deffy DCA opportunity scanner. Analyzes market conditions to identify assets at favorable DCA entry points based on volatility, drawdown, and momentum metrics. Scans across hundreds of tokens for DCA-friendly setups and automates execution with intelligent timing adjustments.',
  },
  {
    id: 'dexswap-monitor-executor',
    name: 'dexswap-monitor-executor',
    author: 'DexSwap',
    authorHandle: '@dexswap',
    tag: 'Skill',
    category: 'trading',
    description: 'DexSwap monitor and executor. Real-time DEX swap monitoring, price impact estimation, and automated execution with slippage protection.',
    downloads: 13200,
    stars: 940,
    installCommand: '> install the dexswap-monitor-executor skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/dexswap-monitor-executor',
    usageExample: '> monitor DEX swaps\n> estimate price impact\n> execute with protection',
    detailedDescription: 'DexSwap comprehensive DEX monitoring and execution system. Monitors real-time swap prices across Uniswap, SushiSwap, PancakeSwap, and other major DEXs. Estimates price impact before execution, and automatically executes trades with configurable slippage protection and MEV resistance.',
  },
  {
    id: 'ermi-agent',
    name: 'ermi-agent',
    author: 'Ermi',
    authorHandle: '@ermi_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'Ermi trading agent. AI-powered market analysis, adaptive strategy selection, and automated execution with continuous learning.',
    downloads: 8400,
    stars: 600,
    installCommand: '> install the ermi-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/ermi-agent',
    usageExample: '> analyze market with AI\n> select adaptive strategy\n> execute with learning',
    detailedDescription: 'Ermi AI-powered trading agent with continuous learning capabilities. Analyzes market conditions using machine learning models, adaptively selects optimal strategies from a curated library based on regime detection, and improves performance through reinforcement learning from trade outcomes.',
  },
  {
    id: 'ermi-meme-sniper',
    name: 'ermi-meme-sniper',
    author: 'Ermi',
    authorHandle: '@ermi_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'Ermi meme sniper. Lightning-fast meme coin detection, launch sniping, and viral momentum trading with automated exit strategies.',
    downloads: 11200,
    stars: 800,
    installCommand: '> install the ermi-meme-sniper skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/ermi-meme-sniper',
    usageExample: '> detect meme launch\n> snipe new token\n> auto-exit on momentum',
    detailedDescription: 'Ermi specialized meme coin sniper agent. Detects new token launches within seconds through mempool monitoring and Telegram/Twitter scanning. Executes lightning-fast sniper purchases with custom gas strategies, and deploys automated exit strategies based on momentum decay and volume divergence.',
  },
  {
    id: 'ethy-ai-trading',
    name: 'ethy-ai-trading',
    author: 'Ethy',
    authorHandle: '@ethy_io',
    tag: 'Skill',
    category: 'trading',
    description: 'Ethy AI trading. Ethereum-native AI trading with on-chain signal generation, smart contract execution, and DeFi integration.',
    downloads: 9800,
    stars: 700,
    installCommand: '> install the ethy-ai-trading skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/ethy-ai-trading',
    usageExample: '> generate on-chain signal\n> execute via smart contract\n> integrate with DeFi',
    detailedDescription: 'Ethy AI trading system native to Ethereum. Generates trading signals from on-chain data including mempool analysis, whale wallet tracking, and DeFi protocol metrics. Executes trades through smart contract interactions with built-in MEV protection and gas optimization.',
  },
  {
    id: 'ethy-ai',
    name: 'ethy-ai',
    author: 'Ethy',
    authorHandle: '@ethy_io',
    tag: 'Skill',
    category: 'trading',
    description: 'Ethy AI core. Machine learning market prediction, pattern recognition, and natural language trading insights for Ethereum markets.',
    downloads: 7600,
    stars: 540,
    installCommand: '> install the ethy-ai skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/ethy-ai',
    usageExample: '> predict market movement\n> recognize pattern\n> get AI insight',
    detailedDescription: 'Ethy AI core machine learning engine for Ethereum market prediction. Trains on-chain and off-chain features to predict price movements, recognizes chart patterns through computer vision, and generates natural language trading insights from complex market data.',
  },
  {
    id: 'ethy-swap-agent',
    name: 'ethy-swap-agent',
    author: 'Ethy',
    authorHandle: '@ethy_io',
    tag: 'Skill',
    category: 'trading',
    description: 'Ethy swap agent. Intelligent DEX swap routing, optimal path finding, and gas-efficient execution across Ethereum DEX aggregators.',
    downloads: 8400,
    stars: 600,
    installCommand: '> install the ethy-swap-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/ethy-swap-agent',
    usageExample: '> find optimal swap route\n> execute gas-efficient swap\n> route across aggregators',
    detailedDescription: 'Ethy intelligent DEX swap agent for Ethereum. Finds optimal swap routes across 1inch, Paraswap, and other aggregators, minimizes gas costs through transaction batching and optimal timing, and executes swaps with automatic slippage protection and MEV resistance.',
  },
  {
    id: 'fixe-base-trader',
    name: 'fixe-base-trader',
    author: 'Fixe',
    authorHandle: '@fixe_trading',
    tag: 'Skill',
    category: 'trading',
    description: 'Fixe Base trader. Specialized trading on Base L2 with fast execution, low fees, and native Base ecosystem protocol integration.',
    downloads: 6200,
    stars: 440,
    installCommand: '> install the fixe-base-trader skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/fixe-base-trader',
    usageExample: '> trade on Base\n> execute fast swap\n> integrate Base protocols',
    detailedDescription: 'Fixe specialized trader for Base Layer 2 network. Leverages Base\'s low transaction fees and fast confirmation times for high-frequency trading strategies. Integrates with native Base DeFi protocols including Aerodrome, Seamless, and Base-native DEXs for optimal liquidity access.',
  },
  {
    id: 'floorbot-agent',
    name: 'floorbot-agent',
    author: 'FloorBot',
    authorHandle: '@floorbot',
    tag: 'Skill',
    category: 'trading',
    description: 'FloorBot NFT floor management. Automated floor sweeping, collection-wide bidding, and NFT flipping strategies with rarity analytics.',
    downloads: 7800,
    stars: 560,
    installCommand: '> install the floorbot-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/floorbot-agent',
    usageExample: '> sweep floor\n> bid on collection\n> flip with rarity',
    detailedDescription: 'FloorBot automated NFT floor management agent. Sweeps collection floors during panic selling, places collection-wide bids at configured price levels, and executes NFT flipping strategies using AI-powered rarity analytics and price momentum detection.',
  },
  {
    id: 'funding-rates-trader',
    name: 'funding-rates-trader',
    author: 'FundingPro',
    authorHandle: '@fundingpro',
    tag: 'Skill',
    category: 'trading',
    description: 'Funding rates trader. Harvest funding rate premiums, execute funding arbitrage, and manage perpetual futures carry strategies.',
    downloads: 11200,
    stars: 800,
    installCommand: '> install the funding-rates-trader skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/funding-rates-trader',
    usageExample: '> harvest funding premium\n> execute funding arb\n> manage carry strategy',
    detailedDescription: 'Funding rates trading specialist. Identifies and harvests funding rate premiums across Binance, Bybit, dYdX, and other perpetual futures exchanges. Executes funding arbitrage by maintaining delta-neutral spot-futures positions, and manages carry strategies with automated rebalancing.',
  },
  {
    id: 'funding-rates-monitor',
    name: 'funding-rates-monitor',
    author: 'FundingPro',
    authorHandle: '@fundingpro',
    tag: 'Skill',
    category: 'trading',
    description: 'Funding rates monitor. Real-time funding rate tracking, exchange comparison, and alert system for funding rate anomalies.',
    downloads: 9800,
    stars: 700,
    installCommand: '> install the funding-rates-monitor skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/funding-rates-monitor',
    usageExample: '> track funding rates\n> compare exchanges\n> alert on anomaly',
    detailedDescription: 'Comprehensive funding rates monitoring system. Tracks real-time funding rates across all major perpetual futures exchanges, compares rates for arbitrage opportunities, and generates alerts when funding rates exceed configured thresholds or show unusual divergence patterns.',
  },
  {
    id: 'funding-rates-tracker',
    name: 'funding-rates-tracker',
    author: 'FundingPro',
    authorHandle: '@fundingpro',
    tag: 'Skill',
    category: 'trading',
    description: 'Funding rates tracker. Historical funding rate analysis, trend identification, and predictive funding rate forecasting for strategy planning.',
    downloads: 7600,
    stars: 540,
    installCommand: '> install the funding-rates-tracker skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/funding-rates-tracker',
    usageExample: '> analyze historical funding\n> identify trend\n> forecast rate',
    detailedDescription: 'Advanced funding rates tracking and analysis system. Maintains historical funding rate databases for major perpetual contracts, identifies funding rate trends and seasonality patterns, and provides predictive funding rate forecasts using time series models for strategy planning.',
  },
];